export default function Trending(){
    return(
        <div>
            Trending
        </div>
    )
}


